import Header from "./components/Header";
import { Outlet, useLocation } from "react-router-dom";
import "./App.scss";
import "./assets/scss/Content.scss";
import "./assets/scss/Button.scss";
import "./assets/scss/Helpers.scss";
import "./assets/scss/Forms.scss";
import "./assets/scss/Modal.scss";
//import './assets/icon-fonts.css';
import ReactRecaptcha3 from 'react-google-recaptcha3';

import Footer from "./components/Footer";
import WhatsApp from "./components/WhatsApp";
import { AuthContext } from "./services/AuthContext";
import React, { useContext, useEffect, useState } from "react";
import { usePage } from "./services/PageContext";
import { RECAPTCHA_TOKEN } from "./Config";

function App() {
  const { isAuthenticated, user, updateOrder } = useContext(AuthContext);
  const { setSiderMenu, isMobileStyle, setIsMobileStyle } = usePage()
  const location = useLocation();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    ReactRecaptcha3.init(RECAPTCHA_TOKEN);
  }, []);/*  */

  useEffect(() => {
    // Guardar la URL actual en sessionStorage cada vez que cambie la URL
    const currentState = location.pathname;
    let prevState = sessionStorage.getItem('currentState');
    const prev = sessionStorage.getItem('prevState');
    if ((currentState != '/registro') && (currentState != '/registro-confirmado') && (currentState != '/olvide')) {
      if (currentState != prevState) {
        //resetPages();
        if (prevState == '/login') {
          prevState = sessionStorage.getItem('prevLogin');
        }
        sessionStorage.setItem('prevState', prevState);
        sessionStorage.setItem('currentState', currentState);
        if (currentState == '/login') {
          sessionStorage.setItem('prevLogin', prev)
        }
        if (prevState == '/pedido-confirmado') {
          updateOrder({});
        }
      }
    } else {
      sessionStorage.setItem('prevState', '/');
    }
    if (currentState.includes('/categoria')) {
      setSiderMenu(isMobileStyle)
    } else {
      setSiderMenu(false)
    }
  }, [location, isMobileStyle]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Limpia el event listener al desmontar el componente
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(()=>{
    setIsMobileStyle(screenWidth<992)
  },[screenWidth])

  return (
    <>
      <div className="App">
        <Header authenticated={isAuthenticated} user={user ? user.name: ''}/>
        <Outlet />
        {/* <WhatsApp /> */}
        <Footer />
      </div>
    </>
  );
}

export default App;
